import React, { useEffect, useState } from 'react';
import { Route, Routes, BrowserRouter, useSearchParams, useNavigate } from "react-router-dom";
import Home from "./views/Home";
import Layout from "./layouts/Layout";
import SelectGame from "./views/SelectGame";
import DailyCheckin from "./views/DailyCheckin";
import DailyTasks from "./views/DailyTasks";
import DailyGamingTasks from "./views/DailyGamingTasks";
import Highlights from "./views/Highlights";
import WeeklyTournaments from "./views/WeeklyTournaments";
import Rewards from "./views/Rewards";
import WeeklyTournamentJoin from "./views/WeeklyTournamentJoin";
import GameChallenges from "./views/GameChallenges";
import { authenticateUser, isAuthenticated, getActiveDayData, updateActiveDay } from './api/auth';
import { getUserProfile } from './api/profile';
import Leaderboard from "./views/Leaderboard";
import CompletedTasks from "./views/CompletedTasks";
import Notifications from "./views/Notifications";
import GameHighlights from "./views/GameHighlights";
import Profile from "./views/Profile";
import EditProfile from "./views/EditProfile";
import FAQs from "./views/FAQs";
import Unsubscribe from "./views/Unsubscribe";
import LearnWin from './views/LearnWin';
import GoogleAnalyticsConditional from './components/GoogleAnalyticsConditional';
import RedeemForm from './views/RedeemForm';
import Thankyou from './views/Thankyou';
import PrivacyPolicy from './views/Terms';
import AimTrain from './views/Games/AimTrain';
import CannonClash2D from './views/Games/CannonClash2D';
import PuzzleRotate from './views/Games/PuzzleRotate';
import TournamentDetails from './views/TournamentDetails';
import SpaceFootball from './views/Games/SpaceFootball';
const fetchActiveDay = async (setShowGameSelector, setShowDailyCheckin) => {
  try {
    if (isAuthenticated()) {
      // await updateActiveDay();

      const activeDayData = await getActiveDayData();
      // const activeDayData = {
      //   "success": true,
      //   "active_streak": 1,
      //   "streak_to_claim": 2,
      //   "amount_to_claim": 20,
      //   "rewardClaimed": false,
      //   "challengesAllocated": false,
      //   "gameId": null,
      // }

      // console.log('Active day data:', activeDayData);

      if (activeDayData) {
        sessionStorage.setItem("activeDayData", JSON.stringify(activeDayData));
        sessionStorage.setItem('activeDay', activeDayData.active_streak);
        sessionStorage.setItem('gameId', activeDayData.gameId);

        const gameSelectorShown = sessionStorage.getItem('gameSelectorShown');
        const dailyCheckinShown = sessionStorage.getItem('dailyCheckinShown');

        // if (
        // activeDayData.message === "No daily active record find for this user." || !activeDayData.rewardClaimed
        // ) 
        {
          // console.log("REWARD CLAIM 1: " + activeDayData.rewardClaimed);
          if (!dailyCheckinShown) {
            setShowDailyCheckin(true);
            sessionStorage.setItem('dailyCheckinShown', 'true');
          }
        }
        // console.log("GAME ID: " + activeDayData.gameId);
        // console.log("!GAME ID: " + !activeDayData.gameId);
        // console.log("GAME ID === null: " + activeDayData.gameId === null);
        // console.log("GAME ID == null: " + activeDayData.gameId == null);
        // console.log("GAME ID: " + activeDayData.gameId === undefined);
        if (!activeDayData.gameId) {
          if (!gameSelectorShown) {
            // console.log("GAME SELECTOR 1: " + activeDayData.gameId);
            sessionStorage.setItem('activeDay', JSON.stringify(activeDayData.active_day));
            setShowGameSelector(true);
            sessionStorage.setItem('gameSelectorShown', 'true');
          }
        }
      }
    }
  } catch (error) {
    // console.error('Error fetching active day:', error);
  }
};

const MsisdnCheck = ({ setShowGameSelector, setShowDailyCheckin }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate()
  useEffect(() => {
    const checkAuth = async () => {
      let msisdn = sessionStorage.getItem('msisdn');
      let refferer = searchParams.get('refferer') || sessionStorage.getItem('refferer') || searchParams.get('referer');
      let authResult;
      if (refferer && refferer === "gamenow") {
        sessionStorage.setItem('gamesNowRef', true);
      }
      if (!msisdn) {
        msisdn = searchParams.get('a');
        if (msisdn) {
          // console.log("MSISDN found in URL, attempting authentication");
          if (refferer === "gamenow") {
            authResult = await authenticateUser(msisdn, refferer);
          } else {
            // console.log("No Referrer")
            authResult = await authenticateUser(msisdn, null);
          }
          if (!authResult.success) {
            // console.error("Authentication failed:", authResult.error);
            redirectToLogin();
          } else {
            await fetchActiveDay(setShowGameSelector, setShowDailyCheckin);
          }
        } else {
          // console.log("MSISDN not found in sessionStorage or URL. Redirecting to login.");
          redirectToLogin();
        }
      } else if (!isAuthenticated()) {
        const authResult = await authenticateUser(msisdn, refferer);
        if (!authResult.success) {
          // console.error("Re-authentication failed:", authResult.error);
          redirectToLogin();
        } else {
          await fetchActiveDay(setShowGameSelector, setShowDailyCheckin);
        }
      } else {
        await fetchActiveDay(setShowGameSelector, setShowDailyCheckin);
      }

      const rew = searchParams.get('r');
      if(rew) {
        if(rew == 1) {
          setShowDailyCheckin(false)
          setShowGameSelector(false)
          navigate('/rewards')
        }
      }
    };

    const redirectToLogin = () => {
      const loginUrl = process.env.REACT_APP_LOGIN_URL;
      if (window.location.pathname === '/tasks' || window.location.pathname === '/join-tournament' || window.location.pathname === '/redeem' || window.location.pathname == "/profile") {
        // console.log("REDIR")
        if (sessionStorage.getItem("gamesNowRef") != 'true')
          window.location.href = loginUrl;
      }
    };

    checkAuth();
  }, [searchParams, setShowGameSelector, setShowDailyCheckin]);

  return null;
};

function App() {
  const [showGameSelector, setShowGameSelector] = useState(false);
  const [showDailyCheckin, setShowDailyCheckin] = useState(false);
  const [profileData, setProfileData] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      if (isAuthenticated()) {
        try {
          const response = await getUserProfile();
          if (response.success) {
            setProfileData(response);
            sessionStorage.setItem('profileData', JSON.stringify(response));
          }
        } catch (error) {
          // console.error('Error fetching profile:', error);
        }
      }
    };

    fetchProfile();
  }, []);

  const handleCloseGameSelector = () => {
    setShowGameSelector(false);
  };

  const handleCloseDailyCheckin = () => {
    const activeDayData = JSON.parse(sessionStorage.getItem('activeDayData'));
    setShowDailyCheckin(false);
    if (!activeDayData.gameId) {
      setShowGameSelector(true);
    }
  };

  return (
    <div>

      <BrowserRouter>
        <MsisdnCheck
          setShowGameSelector={setShowGameSelector}
          setShowDailyCheckin={setShowDailyCheckin}
        />
        {/* <GoogleAnalyticsConditional
          trackingId="G-RYPEHMDZMX"  //  JAZZ ESL ID for the login page
        /> */}
        <Layout profileData={profileData}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tasks" element={<DailyTasks />} />
            <Route path="/daily-gaming-tasks" element={<DailyGamingTasks />} />
            <Route path="/game-challenges" element={<GameChallenges />} />
            <Route path="/highlights" element={<Highlights />} />
            <Route path='/game-highlights' element={<GameHighlights />} />
            <Route path="/tournaments" element={<WeeklyTournaments />} />
            <Route path="/join-tournament" element={<WeeklyTournamentJoin />} />
            <Route path="/rewards" element={<Rewards />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/completed" element={<CompletedTasks />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/learn-win" element={<LearnWin />} />
            <Route path='/redeem' element={<RedeemForm />} />
            <Route path='/thankyou' element={<Thankyou />} />
            <Route path='/terms-service' element={<PrivacyPolicy />} />
            <Route path='/aim-train' element={<AimTrain />} />
            <Route path='cannon-clash' element={<CannonClash2D />} />
            <Route path='/puzzle-mania' element={<PuzzleRotate />} />
            <Route path='/space-football' element={<SpaceFootball />} />
            <Route path='/tournament/:tournamentId' element={<TournamentDetails />} />
          </Routes>
        </Layout>
        {showGameSelector && <SelectGame isOpen={showGameSelector} onClose={handleCloseGameSelector} />}
        {showDailyCheckin && <DailyCheckin isOpen={showDailyCheckin} onClose={handleCloseDailyCheckin} />}
      </BrowserRouter>
    </div>
  );
}

export default App;